<template>
	<div class="study">
		<publicHeader @child-event="myInfoEvent"></publicHeader>
		<studyHeader :subjectIndex="subjectIndex" :studyNav="studyNav" :myInfo="myInfo" :public="public"></studyHeader>
		<div class="famous w1200">
			<div class="famous_cont">
				<div class="swiper-container famous_banner mat20">
				    <div class="swiper-wrapper">
				        <div class="swiper-slide radius8" v-for="(item,index) in famousBanner" :key="index">
									<router-link :to="item.jump_url"><img :src="item.pic" class="block radius8" /></router-link>
								</div>
				    </div>
				    <div class="swiper-pagination"></div>
				</div>
			</div>
			<div class="flex famous_position">
				<div class="my_position_l cl_gray">
					<img src="../../../static/icon_position.png" class="mar5" />
					<p>当前位置：<router-link to="/" class="cl_gray">首页</router-link>  >  <router-link to="/study" class="cl_gray">趣学习</router-link>  >  名校试卷</p>
				</div>
				<div class="my_position_r cl_violet" @click="$router.go(-1)"><span class="mar5">返回上级</span><img src="../../../static/return_violet.png" /></div>
			</div>
			<div class="famous_screen flex">
				<div class="famous_screen_list">
					<span class="cl_gray f18px">大类：</span>
					<el-select v-model="typeValue" clearable placeholder="全部" @change="typeSelect">
						<el-option v-for="(item,index) in type":key="index" :label="item":value="item"></el-option>
					</el-select>
				</div>
				<div class="famous_screen_list">
					<span class="cl_gray f18px">年级：</span>
					<el-select v-model="gradeValue" clearable placeholder="全部" @change="gradeSelect">
						<el-option v-for="item in grade":key="item.gradeId" :label="item.gradeName":value="item.gradeId"></el-option>
					</el-select>
				</div>
				<div class="famous_screen_list">
					<span class="cl_gray f18px">学科：</span>
					<el-select v-model="subjectValue" clearable placeholder="全部" @change="subjectSelect">
						<el-option v-for="item in subject":key="item.subjectId" :label="item.subjectName":value="item.subjectId"></el-option>
					</el-select>
				</div>
				<div class="famous_screen_list">
					<span class="cl_gray f18px">省份：</span>
					<el-select v-model="provinceValue" clearable placeholder="全部" @change="provinceSelect">
						<el-option v-for="item in province":key="item.id" :label="item.name":value="item.id"></el-option>
					</el-select>
				</div>
				<div class="famous_screen_list">
					<span class="cl_gray f18px">教材：</span>
					<el-select v-model="materialValue" clearable placeholder="全部" @change="materialSelect">
						<el-option v-for="item in material":key="item.Id" :label="item.Name":value="item.Id"></el-option>
					</el-select>
				</div>
			</div>
			<div class="famous_list_cont" v-if="list.length > 0">
				<router-link :to="{ path: '/famous_download', query: { id: item.id }}" v-for="(item,index) in list" :key="index" class="famous_list flex mab20">
					<p class="famous_list_l f16px cl_dark">• <i>{{item.name}}</i></p>
					<span class="f18px cl_gray">{{item.add_time}}</span>
				</router-link>
			</div>
			<div class="famous_page flex" v-if="list.length > 0">
				<div class="famous_page_l f16px cl_gray">共 {{total}} 条记录 页次：{{currentPage}}/{{Math.ceil(total/pageSize)}}页   {{pageSize}}条/页</div>
				<div class="famous_page_r cl_dark">
					<el-pagination background layout="prev, pager, next, jumper" @size-change="handleSizeChange" 
					@current-change="handleCurrentChange" :page-size="pageSize" :current-page="currentPage" :total="total"></el-pagination>
				</div>
			</div>
			<div class="choice_empty tc f18px cl_gray" v-if="list.length == 0">
				<p>找不到内容，请重新选择</p>
			</div>
		</div>
		<vfooter @child-event="publicEvent"></vfooter>
	</div>
</template>

<script>
	import publicHeader from '../../components/header.vue'
	import studyHeader from '../../components/study_header.vue'
	import vfooter from '../../components/footer.vue'
	import '@/assets/js/swiper.min.js'
	import '@/assets/css/swiper.min.css'
	export default {
	  name: 'famous',
		components: {
			publicHeader,
			studyHeader,
			vfooter,
		},
	  props: {
	    
	  },
		data () {
			return {
				subjectIndex: false, //学科分类显示
				studyNav: 3,
				myInfo: {},
				public: {},
				famousBanner: [],
				typeValue: "", //筛选
				gradeValue: "",
				subjectValue: "",
				provinceValue: "",
				materialValue: "",
				type: [],
				grade: [],
				subject: [],
				province: [],
				material: [],
				list: [], //试卷列表
				currentPage: 1, //当前页数
				pageSize: 20, //每页数量
				total: 0, //总页数
			}
		},
		mounted() {
			this.getType();
			this.getSubject();
			this.getProvince();
			this.getMaterial();
			this.getGrade();
			this.getList();
			this.getBanner();
		},
		created() {
			
		},
		methods: {
			myInfoEvent (data) {
				this.myInfo = data;
			},
			publicEvent (data) {
				this.public = data;
			},
			getBanner () {
				this.$get("/api/base/get_banner_data",{
					page_name: "study_topic_banner_cate_id",
				})
				.then(res => {
					this.famousBanner = res.data;
					//轮播图
					var mySwiper = new Swiper('.famous_banner', {
						autoplay: {
							disableOnInteraction: false,
						},
						pagination: {
							el: '.swiper-pagination',
							clickable :true,
						},
						observer:true,
						observeParents:true,
					});
				});
			},
			//获取大类
			getType () {
				this.$get("/api/material/get_type_data",{})
				.then(res => {
					this.type = res.data;
				});
			},
			//年级
			getGrade () {
				this.$get("/api/material/get_grade_data",{
					id: localStorage.getItem("pharseId"),
				})
				.then(res => {
					this.grade = res.data;
				});
			},
			//学科
			getSubject () {
				this.$get("/api/material/get_subject_data",{})
				.then(res => {
					this.subject = res.data;
				});
			},
			//省份
			getProvince () {
				this.$get("/api/careerbible/get_province_data",{})
				.then(res => {
					this.province = res.data;
				});
			},
			//教材
			getMaterial () {
				this.$get("/api/material/get_edition_data",{})
				.then(res => {
					this.material = res.data;
				});
			},
			//试卷列表
			getList () {
				var that = this;
				var params = {};
				params.type = that.typeValue;
				params.grade_id = that.gradeValue;
				params.subject_id = that.subjectValue;
				params.province_id = that.provinceValue;
				params.edition_id = that.materialValue;
				params.pharse_id = localStorage.getItem("pharseId");
				params.page = that.currentPage;
				params.limit = that.pageSize;
				that.$get("/api/material/get_material_list",params)
				.then(res => {
					that.list = [];
					that.list = res.data.data;
					that.total = res.data.total;
				});
			},
			typeSelect (e) {
				this.currentPage = 1;
				this.getList();
			},
			gradeSelect (e) {
				this.currentPage = 1;
				this.getList();
			},
			subjectSelect (e) {
				this.currentPage = 1;
				this.getList();
			},
			provinceSelect (e) {
				this.currentPage = 1;
				this.getList();
			},
			materialSelect (e) {
				this.currentPage = 1;
				this.getList();
			},
			
			handleSizeChange: function (size) {
				this.pageSize = size;
			},
			handleCurrentChange: function(currentPage){
				this.currentPage = currentPage;
				this.getList();
			},
		},
	}
</script>

<style>
</style>
